import React, { useContext } from 'react'
import {Form, InputNumber} from "antd";
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";

const UpdateProductionRatio = ({id, row}) => {
    const [form] = Form.useForm()
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    const handleRatioChange = (list) => {
        let mockProduction = Object.assign({}, recipeById)
        mockProduction.recipeProductionCosts[id].ratio = list.updateRatio
        setRecipeById(mockProduction)
    }

    return(
        <React.Fragment>
            <Form
                form={form}
            >
                <Form.Item
                    name={'updateRatio'}
                    initialValue={recipeById.recipeProductionCosts[id].ratio}
                >
                    <InputNumber
                        step={0.1}
                        onChange={() => handleRatioChange(form.getFieldsValue())}
                    />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default UpdateProductionRatio